import { apiAgencia } from 'services/api';

class TelevisionApi {
  index() {
    return apiAgencia.post('/ridTvLogger');
  }
}

export default new TelevisionApi();
